<template>
  <div style="gap: 12px;" class="d-flex flex-column">
  
    <OriginalLoadInfo :order="order" />
   
    <BaseAccordion title="Added Truckers" :is-open="true">
      <template v-slot:title>
          <div class="d-flex align-items-center" style="gap: 4px; margin-right: 24px;">
            <RoundedButton
              v-for="status in truckerStatus"
              :key="status.text"
              type="filter"
              :active="activeTruckerStatus === status.text"
              @click.stop="activeTruckerStatus = activeTruckerStatus === status.text ? null : status.text"
            >
              {{ status.text | capitalize }}
            </RoundedButton>
          </div>
      </template>
      <AddedTruckersList :status="activeTruckerStatus" :order="order" :errors="errors" :refresh="truckerRefresh" @refresh="$emit('refresh')" />
    </BaseAccordion>

    <BaseAccordion title="Add New Trucker" :is-open="true">
      <AddNewTruckerForm :order="order" @refresh="truckerRefresh = !truckerRefresh" />
    </BaseAccordion>

    <BaseAccordion title="Send Email Offer (HCL)" :is-open="false">
     <SendOfferHCL :order="order" :is-dispatched="!!order.carrierId" @refresh="truckerRefresh = !truckerRefresh" />
    </BaseAccordion>

     <BaseAccordion title="Manual Dispatch" :is-open="true">
        <ValidationObserver ref="observer">
          <form @submit.prevent="submit()">
            <CarrierSelector :balance-fields="order" v-model="selectedCarrierId" :preselected="carrierId" />
            <FormFieldsErrors :errors="errors" />

            <LoadingIndicator v-if="requestInProgress" />
            <div v-else class="mb-4">

              <ValidatedSelect
                rules="required"
                label="Dispatch Method"
                id="dispatchMethod"
                v-model="order.dispatchMethodId"
                :options="dispatchMethods"
              />
              <button v-if="!order.carrierId" :disabled="saving" class="btn btn-primary" type="submit">Dispatch</button>
            </div>
          </form>
        </ValidationObserver>
        <button class="btn btn-primary mb-4" @click="updateBalance">Update</button>
        <button class="btn btn-primary mb-4" @click="updateBalanceAndSend">Update and Resend</button>
        
        <!-- Dispatched to card  -->
        <div v-if="order.carrierId" class="dispatched-card">
          <div class="d-flex align-items-center" style="font-size:25px; ">
             <BaseIcon name="check-circle" :color="dispatchedIconColor" size="30" style="margin-right: 8px;"></BaseIcon>
            <b>Dispatched to 
               <b-link v-if="order.carrier.contact" :to="carrierLink(order.carrier)"> {{ order.carrier.contact.company }}</b-link>
                <span v-else>Carrier information missing!</span>
            </b>
          </div>
          <div>
            <div class="d-flex align-items-start" >
              <div class="d-flex flex-column" style="margin-right: 125px;">
                <div><b>Signed at:</b></div>
                <div>
                  <span v-if="order.signedAt">{{order.signedAt | formatDateTime}}</span>
                  <span v-else>Not Signed</span>
                </div>
              </div>
              <ValidatedInput v-if="!resendRequestInProgress &&  order.signedAt" :id="toAddress" v-model="toAddress" label="Email" :errors="errors.toAddress"/>
            </div>
          </div>
          <div>
            <LoadingIndicator v-if="resendRequestInProgress" style="margin-right: 8px;"/>
            <button v-if="!resendRequestInProgress &&  order.signedAt" class="btn btn-primary" @click="resendDispatchSheet" style="margin-right: 8px;">Resend dispatch sheet</button>
            <LoadingIndicator v-if="requestInProgress" />
            <button v-else class="btn btn-danger" @click="openUndispatchModal">Revoke dispatch</button>
          </div>
        </div>
    </BaseAccordion>

    <UndispatchReasonModal
      v-if="showUndispatchModal"
      :on-close="closeUndispatchModal"
      :submitting="requestInProgress"
      :server-error="undispatchServerError"
      @confirm="revokeOrderDispatch"
    />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import ValidatedInput from '@/components/shared/ValidatedInput';
import ValidatedSelect from '@/components/shared/ValidatedSelect';
import CarrierSelector from '@/components/shared/CarrierSelector';
import FormFieldsErrors from '@/components/shared/formFields/FormFieldsErrors';
import LoadingIndicator from '@/components/shared/LoadingIndicator.vue';
import { apiRequest } from '@/api/apiRequest';
import dispatchMethodsMixin from '@/mixins/dispatchMethods';
import OriginalLoadInfo from '@/components/shared/OriginalLoadInfo.vue';
import BaseAccordion from '@/components/shared/BaseAccordion.vue';
import AddNewTruckerForm from '@/components/shared/form/AddNewTruckerForm.vue';
import AddedTruckersList from '@/components/shared/AddedTruckersList.vue';
import SendOfferHCL from '@/components/shared/SendOfferHCL.vue';
import RoundedButton from '@/components/shared/RoundedButton.vue';
import BaseIcon from '@/components/shared/BaseIcon.vue';
import UndispatchReasonModal from '@/components/shared/UndispatchReasonModal';

export default {
  name: 'OrderDispatch',
  data() {
    return {
      errors: {},
      toAddress: this.order.carrierId ? this.order.carrier.contact.email : '',
      selectedCarrierId:  null,
      requestInProgress: false,
      resendRequestInProgress: false,
      saving: false,
      balanceFields: null,
      activeTruckerStatus: 'all',
      truckerRefresh: false,
      showUndispatchModal: false,
      undispatchServerError: '',
      truckerStatus:[
        { text: 'all' },
        { text: 'active' },
        { text: 'pending' },
        { text: 'queued'},
        { text: 'declined'},
        { text: 'withdrawn' },
        { text: 'expired' },
        { text: 'accepted' },
        { text: 'dispatched' },
      ]
    };
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  mixins: [dispatchMethodsMixin],
  components: { CarrierSelector, FormFieldsErrors, LoadingIndicator, ValidatedInput, ValidatedSelect, OriginalLoadInfo, BaseAccordion, AddNewTruckerForm, AddedTruckersList, SendOfferHCL, RoundedButton, BaseIcon, UndispatchReasonModal },
  computed: {
    carrierId(){
      return this.$route.query.carrierId ? parseInt(this.$route.query.carrierId) : null;
    },
    dispatchedIconColor() {
      return localStorage.getItem('themeSettingsStyle') === 'dark' ? '#95D596' : '#367B45';
    }
  },
  methods: {
    async submit() {
      this.saving = true;
      const isValid = await this.$refs.observer.validate();
      if (isValid && this.selectedCarrierId) {
        const requestLeadParams = this.order;
        const response = await ApiClient.leads.put({ id: this.order.id, body: requestLeadParams });
        if (response.status === 200) {
          this.dispatchOrder();
        }
      } else {
        this.handleSendErrorToast({ message: 'Required field(s) missing.' });
      }
      this.saving = false;
    },
    async updateBalanceAndSend() {
      let res = await this.updateBalance();
      if (res && this.order.signedAt) {
        this.resendDispatchSheet();
      }
    },
    async updateBalance() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        const requestLeadParams = this.order;
        const response = await ApiClient.leads.put({ id: this.order.id, body: requestLeadParams });
        if (response.status === 200) {
          this.$emit('refresh');
          return true;
        }
      } else {
        this.handleSendErrorToast({ message: 'Required field(s) missing.' });
      }
      return false;
    },
    handleSendErrorToast({ message }) {
      this.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
      });
    },
    async dispatchOrder() {
      if (this.requestInProgress) return;
      this.requestInProgress = true;
      const response = await ApiClient.leads.dispatch.post({
        leadId: this.order.id,
        body: { 
          carrierId: this.selectedCarrierId,
          dispatchMethodId: this.order.dispatchMethodId
        },
      });
      this.requestInProgress = false;

      if (response.status === 200) {
        this.errors = {};
        this.$emit('refresh');
      } else if (response.status === 400) {
        this.errors = { generalError: response.data.message };
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      }
    },
    openUndispatchModal() {
      this.undispatchServerError = '';
      this.showUndispatchModal = true;
    },
    closeUndispatchModal() {
      if (this.requestInProgress) return;
      this.showUndispatchModal = false;
      this.undispatchServerError = '';
    },
    async revokeOrderDispatch(payload) {
      if (this.requestInProgress) return;
      this.requestInProgress = true;
      this.undispatchServerError = '';
      const response = await ApiClient.leads.dispatch.delete({
        leadId: this.order.id,
        body: payload,
      });
      this.requestInProgress = false;

      if (response.status === 200) {
        this.errors = {};
        this.selectedCarrierId = null;
        this.showUndispatchModal = false;
        this.$emit('refresh');
      } else if (response.status === 400) {
        this.undispatchServerError = response.data.message || 'Undispatch failed';
      } else if (response.status === 422) {
        const firstError = response.data.errors
          ? Object.values(response.data.errors)[0]
          : null;
        this.undispatchServerError = (firstError && firstError[0]) || 'Validation failed';
      } else {
        this.undispatchServerError = 'Unexpected error, try again';
      }
    },
    async resendDispatchSheet() {
      if (this.resendRequestInProgress) return;
      this.resendRequestInProgress = true;
      const response = await ApiClient.leads.dispatch.resend({ leadId: this.order.id, body: { toAddress: this.toAddress } });
      this.resendRequestInProgress = false;

      if (response.status === 200) {
        this.errors = {};
      } else if (response.status === 400) {
        this.errors = { generalError: response.data.message };
      }
    },
    defaultPaymentOptions() {
      if (this.balanceFields.balanceTermStart == null && this.balanceFields.balanceTerm == null && this.balanceFields.balancePaymentMethod == null) {
        if (this.balanceFields.carrierOwesCompany > 0) {
          this.order.balanceTermStartId = 2;
          this.order.balanceTermId = 1;
          this.order.balancePaymentMethodId = 2;
        }
        if (this.balanceFields.companyOwesCarrier > 0) {
          this.order.balanceTermStartId = 3;
          this.order.balanceTermId = 3;
          this.order.balancePaymentMethodId = 3;
        }
      }

      if (this.order.dispatchMethodId == null){
        this.order.dispatchMethodId = 1;
      }
    },
     carrierLink(carrier) {
      return carrier ? { name: 'CarrierDetails', params: { id: carrier.id } } : null;
    },
  },
  watch: {
    order: {
      immediate: true,
      async handler({ id }) {
        const response = await apiRequest({ path: `/leads/${id}/balance` });
        this.balanceFields = response.data.data;
        this.defaultPaymentOptions();
      },
    },
  },
};
</script>

<style>
.dispatched-card{
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 24px;
  background-color: #EFF6EC;
  color: #4E5155;
  gap: 24px;
}

.dark-style .dispatched-card{
   background-color: #2B3831;
   color: #FFFFFF;
}

</style>

